'use client';

import React, { type FC, type HTMLAttributes, type ReactNode } from 'react';

import { Button, type ButtonProps } from '@/components/buttons/button';
import { useOut } from '@/hooks/use-out';
import { cn } from '@/utils/class-name';

interface OutButtonProps extends HTMLAttributes<unknown> {
    url?: string;
    affiliate?: Graphql.Firm['affiliate'];
    theme?: ButtonProps['theme'];
    children: ReactNode;
}

export const OutButton: FC<OutButtonProps> = ({ url, affiliate, theme = 'orange', className, children, ...props }) => {
    const redirect = useOut(url, affiliate);

    return (
        <Button {...props} icon="lead" className={cn('w-100', className)} theme={theme} onClick={redirect}>
            {children}
        </Button>
    );
};
